import { render, staticRenderFns } from "./LocationSetupMap.vue?vue&type=template&id=47131477&scoped=true&lang=pug"
import script from "./LocationSetupMap.vue?vue&type=script&lang=js"
export * from "./LocationSetupMap.vue?vue&type=script&lang=js"
import style0 from "./LocationSetupMap.vue?vue&type=style&index=0&id=47131477&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47131477",
  null
  
)

export default component.exports